import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Form, Spinner } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function CostCenterPickerModal({ show, onHide, onSelect }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchItems = async () => {
    try {
      setLoading(true);

      const data = await authFetch(
        `/bxcentrucost?skip=0&limit=2000&sort_by=code&sort_order=asc`,
      );

      const rows = Array.isArray(data) ? data : (data.items ?? []);
      setItems(rows);
    } catch (e) {
      console.error("Eroare la încărcare centre cost:", e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchItems();
      setSearch("");
    }
  }, [show]);

  const filtered = items.filter((it) => {
    const q = search.toLowerCase();
    return (
      String(it.code ?? it.cod ?? "")
        .toLowerCase()
        .includes(q) ||
      String(it.denumire ?? it.name ?? "")
        .toLowerCase()
        .includes(q)
    );
  });

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Alege centru de cost</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          placeholder="Caută după cod sau denumire..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="mb-3"
        />

        {loading ? (
          <Spinner />
        ) : (
          <Table hover size="sm">
            <thead>
              <tr>
                <th style={{ width: 120 }}>Cod</th>
                <th>Denumire</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((it) => (
                <tr
                  key={it.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onSelect(it);
                    onHide();
                  }}
                >
                  <td style={{ fontFamily: "monospace" }}>
                    {it.code ?? it.cod}
                  </td>
                  <td>{it.denumire ?? it.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
